import { cn } from '@/utils/cn';

interface ShellProps {
  children: React.ReactNode;
  className?: string;
}

export function Shell({ children, className }: ShellProps) {
  return (
    <div className={cn('flex h-screen overflow-hidden bg-[#fafafa] font-sans antialiased text-slate-900', className)}>
      {children}
    </div>
  );
}
